import React, { useState } from "react";
import CustomModal from "../../../components/shared/CustomModal/CustomModal";
import { Table, message } from "antd";
import CustomUploadField from "../../../components/shared/new Form/Fields/CustomUploadFile";
import CustomButton from "../../../components/global/Button/CustomButton";
import {
  BULK_UPLOAD_QUIZ_OPTIONS,
  QUIZ_TEMPLATE_FILE,
} from "../../../assets/FormFeilds/Config/config";
import * as XLSX from "xlsx";

const dataSource = [
  {
    key: 1,
    questionType: "MCQ_SINGLE",
    questionText: "What is GCP?",
    points: "10",
    option1: "Google Cloud Platform",
    option2: "General Compute Protocol",
    option3: "Global Cache Provider",
    option4: "",
    option5: "",
    correctAnswer: "1",
  },
  {
    key: 2,
    questionType: "MCQ_SINGLE",
    questionText: "What does CPU stand for?",
    points: "5",
    option1: "Central Processing Unit",
    option2: "Computer Personal Unit",
    option3: "",
    option4: "",
    option5: "",
    correctAnswer: "1",
  },
  {
    key: 3,
    questionType: "MCQ_MULTIPLE",
    questionText: "Which of these are Google Cloud services?",
    points: "10",
    option1: "Compute Engine",
    option2: "BigQuery",
    option3: "Azure Functions",
    option4: "Cloud Storage",
    option5: "AWS Lambda",
    correctAnswer: "1,2,4",
  },
  {
    key: 4,
    questionType: "MCQ_MULTIPLE",
    questionText: "Which of these are programming languages?",
    points: "10",
    option1: "Python",
    option2: "HTML",
    option3: "Java",
    option4: "CSS",
    option5: "",
    correctAnswer: "1,3",
  },
  {
    key: 5,
    questionType: "SHORT_ANSWER",
    questionText:
      "Explain what object detection does in an exam proctoring system.",
    points: "10",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    correctAnswer:
      "Looks for things around the student that shouldn't be there during an exam, like a phone, a book, or notes.",
  },
  {
    key: 6,
    questionType: "SHORT_ANSWER",
    questionText: "What is the main benefit of using cloud computing?",
    points: "5",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    option5: "",
    correctAnswer:
      "On-demand scalability without owning physical infrastructure.",
  },
  {
    key: 7,
    questionType: "MCQ_SINGLE",
    questionText: "Which company developed GCP?",
    points: "10",
    option1: "Google",
    option2: "Microsoft",
    option3: "Amazon",
    option4: "IBM",
    option5: "Oracle",
    correctAnswer: "1",
  },
  {
    key: 8,
    questionType: "MCQ_MULTIPLE",
    questionText: "Which are NoSQL databases?",
    points: "10",
    option1: "MongoDB",
    option2: "MySQL",
    option3: "Cassandra",
    option4: "PostgreSQL",
    option5: "Firestore",
    correctAnswer: "1,3,5",
  },
];

const columns = [
  { title: "Question Type", dataIndex: "questionType" },
  { title: "Question Text", dataIndex: "questionText" },
  { title: "Points", dataIndex: "points" },
  { title: "Option 1", dataIndex: "option1" },
  { title: "Option 2", dataIndex: "option2" },
  { title: "Option 3", dataIndex: "option3" },
  { title: "Option 4", dataIndex: "option4" },
  { title: "Option 5", dataIndex: "option5" },
  { title: "Correct Answer", dataIndex: "correctAnswer" },
];

const BulkUploadModal = ({
  bulkUploadModalVisible,
  setBulkUploadModalVisible,
  onParsedDataSave,
}) => {
  const [downloadFormat, setDownloadFormat] = useState("csv");
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);

  const handleFormatSelect = (format) => {
    setDownloadFormat(format);
    setBulkUploadModalVisible(false);
    setIsDetailModalVisible(true);
  };

  const confirmDownloadTemplate = () => {
    if (!downloadFormat || !QUIZ_TEMPLATE_FILE?.[downloadFormat]) {
      message.error("Selected template format is not available.");
      return;
    }

    const link = document.createElement("a");
    link.href = QUIZ_TEMPLATE_FILE[downloadFormat];
    link.download = `bulk_upload_template.${downloadFormat}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    message.success(`Template downloaded (${downloadFormat.toUpperCase()})`);
  };

  const handleFileChange = (info) => {
    let newFileList = [...info.fileList];
    setFileList(newFileList);

    const uploadedFile = info.file || (newFileList[0] && newFileList[0].originFileObj);

    if (uploadedFile) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array", raw: true });

          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          const customKeys = [
            "questionType",
            "questionText",
            "points",
            "option1",
            "option2",
            "option3",
            "option4",
            "option5",
            "correctAnswer",
          ];

          const rawJsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: customKeys,
            range: 1,
            raw: false,
            defval: "",
          });

          const normalizeAnswer = (type, value) => {
  const str = String(value ?? "").trim();
  if (type === "SHORT_ANSWER") return str;          // leave text as is
  return str
    .split(/[,;\s]+/)                               // "1, 2 ,4" or "1;2;4" → ["1","2","4"]
    .filter(Boolean)
    .join(",");
};

          const formattedData = rawJsonData.map((item, index) => ({
            key: index + 1,
            questionType: item.questionType || "single",
            questionText: item.questionText || "",
            points: String(item.points || 0),
            option1: item.option1 || "",
            option2: item.option2 || "",
            option3: item.option3 || "",
            option4: item.option4 || "",
            option5: item.option5 || "",
            correctAnswer: normalizeAnswer(item.questionType, item.correctAnswer),
          }));

          if (onParsedDataSave) {
            onParsedDataSave(formattedData);
          }

          setIsDetailModalVisible(false);
          message.success("File uploaded & parsed successfully!");
        } catch (error) {
          console.error("Error parsing file:", error);
          message.error("Failed to parse file content.");
        }
      };

      reader.readAsArrayBuffer(uploadedFile.originFileObj || uploadedFile);
    }
  };

  return (
    <>
      {/* Step 1: Format Selection Modal */}
      <CustomModal
        visible={bulkUploadModalVisible}
        onClose={() => setBulkUploadModalVisible(false)}
        width={600}
      >
        <div className="flex flex-col gap-[7px] p-4">
          <div className="flex gap-3 w-full">
            {BULK_UPLOAD_QUIZ_OPTIONS.map((option) => (
              <CustomButton
                key={option.value}
                onClick={() => handleFormatSelect(option.value)}
                className="flex-1 py-2 px-4 border-2 border-[#910E11] rounded-[10px] text-[#910E11] font-medium text-sm hover:bg-[#910E11] hover:text-white transition-colors cursor-pointer"
              >
                {option.label}
              </CustomButton>
            ))}
          </div>
          <span className="text-xs text-[rgba(70,70,70,0.6)]">
            Note: Only upload CSV, XLSX files for bulk users.
          </span>
        </div>
      </CustomModal>

      {/* Step 2: Details & Upload Modal */}
      <CustomModal
        title={`Bulk Upload Quiz Questions (${downloadFormat.toUpperCase()})`}
        visible={isDetailModalVisible}
        width={800}
        onClose={() => setIsDetailModalVisible(false)}
      >
        <p className="text-[rgba(70,70,70,1)] text-sm mb-0">
          Please ensure you enter all the quiz details strictly in the format
          provided in the downloaded template. Incorrect formatting may lead to
          errors during bulk upload.
        </p>

        <Table
          size="small"
          pagination={false}
          bordered
          dataSource={dataSource}
          columns={columns}
          className="mt-4 mb-4"
          scroll={{ x: 1200 }}
        />

        <CustomUploadField
          accept={downloadFormat === "csv" ? ".csv" : ".xlsx,.xls"}
          fileList={fileList}
          handleFileChange={handleFileChange}
          disabled={false}
        />

        <div className="flex gap-2.5 mt-6 w-full">
          <CustomButton
            variant="primary"
            onClick={confirmDownloadTemplate}
            style={{ width: "50%" }}
          >
            Download {downloadFormat.toUpperCase()} Template
          </CustomButton>
          <CustomButton
            variant="outlined"
            onClick={() => setIsDetailModalVisible(false)}
            style={{ width: "50%" }}
          >
            Cancel
          </CustomButton>
        </div>
      </CustomModal>
    </>
  );
};

export default BulkUploadModal;
